/* Stelvio - homepage: caroselli (frecce, barra di avanzamento, trascinamento col mouse),
   schede della linea in evidenza, indice delle collezioni (foto che cambia), pallini colore delle card. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  function setupScroller(sc) {
    if (sc.__sch) return; sc.__sch = true;
    var track = sc.querySelector('[data-sch-track]');
    if (!track) return;
    var prev = sc.querySelector('[data-sch-prev]');
    var next = sc.querySelector('[data-sch-next]');
    var bar = sc.querySelector('[data-sch-progress]');
    var thumb = bar ? bar.querySelector('i') : null;
    /* una "pagina" = tutte le schede interamente visibili: la prima scheda tagliata a destra diventa la prima a sinistra */
    function step() {
      var first = track.firstElementChild;
      if (!first) return track.clientWidth * 0.8;
      var w = first.getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 16;
      var per = Math.max(1, Math.floor((track.clientWidth + gap + 2) / (w + gap)));
      return per * (w + gap);
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      if (bar && thumb) {
        var ratio = track.scrollWidth > 0 ? Math.min(1, track.clientWidth / track.scrollWidth) : 1;
        var bw = bar.clientWidth;
        var tw = Math.max(32, bw * ratio);
        var pos = max > 0 ? (track.scrollLeft / max) * (bw - tw) : 0;
        thumb.style.width = tw + 'px';
        thumb.style.transform = 'translateX(' + pos + 'px)';
        bar.style.visibility = max > 2 ? 'visible' : 'hidden';
      }
      sc.classList.toggle('is-static', max <= 2);
    }
    sc.__schUpdate = update;
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    if (finePointer) {
      var down = false, moved = false, startX = 0, startL = 0;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; moved = false; startX = e.clientX; startL = track.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 5) { moved = true; track.classList.add('is-drag'); }
        if (moved) track.scrollLeft = startL - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!down) return;
        down = false;
        if (moved) {
          track.classList.remove('is-drag');
          setTimeout(function () { moved = false; }, 0);
        }
      });
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }
  }
  function setupTabs(box) {
    if (box.__sch) return; box.__sch = true;
    var tabs = Array.prototype.slice.call(box.querySelectorAll('[role="tab"]'));
    var scope = box.closest('section') || document;
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) {
          panel.hidden = !on;
          if (on && panel.__schUpdate) panel.__schUpdate();
        }
      });
      /* la scala dei modelli (sotto il testo) segue la scheda scelta */
      var id = tab.getAttribute('data-tab-id');
      scope.querySelectorAll('[data-tab-ref]').forEach(function (el) { el.hidden = el.getAttribute('data-tab-ref') !== id; });
      if (focus) tab.focus();
    }
    /* elenco delle categorie sotto il testo: apre la scheda qui sotto invece di cambiare pagina */
    scope.querySelectorAll('[data-tab-go]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
        var target = tabs.filter(function (t) { return t.getAttribute('data-tab-id') === a.getAttribute('data-tab-go'); })[0];
        if (!target) return;
        e.preventDefault();
        select(target);
        var top = box.getBoundingClientRect().top + window.pageYOffset - 96;
        window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); select(tabs[(i + 1) % tabs.length], true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); select(tabs[(i - 1 + tabs.length) % tabs.length], true); }
      });
    });
  }
  function setupIndex(box) {
    if (box.__sch) return; box.__sch = true;
    var rows = Array.prototype.slice.call(box.querySelectorAll('[data-sch-row]'));
    var pics = Array.prototype.slice.call(box.querySelectorAll('[data-sch-pic]'));
    function activate(i) {
      rows.forEach(function (r, k) { r.classList.toggle('is-active', k === i); });
      pics.forEach(function (p, k) {
        var on = k === i;
        if (on && p.loading === 'lazy') p.loading = 'eager';
        p.classList.toggle('is-active', on);
      });
    }
    rows.forEach(function (r, i) {
      r.addEventListener('mouseenter', function () { activate(i); });
      r.addEventListener('focus', function () { activate(i); });
    });
    activate(0);
    /* su computer: scendendo, si accende la riga piu' vicina a meta' schermo e la foto cambia da sola
       (calcolato a ogni scroll, cosi' funziona anche scorrendo veloce e sull'ultima riga) */
    if (window.matchMedia('(min-width: 990px)').matches) {
      var ticking = false, current = 0;
      function nearest() {
        ticking = false;
        var box_r = box.getBoundingClientRect();
        if (box_r.bottom < 0 || box_r.top > window.innerHeight) return;
        var line = window.innerHeight * 0.46, best = 0, bd = Infinity;
        rows.forEach(function (r, i) {
          var b = r.getBoundingClientRect();
          var d = line < b.top ? b.top - line : (line > b.bottom ? line - b.bottom : 0);
          if (d < bd) { bd = d; best = i; }
        });
        if (best !== current) { current = best; activate(best); }
      }
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; window.requestAnimationFrame(nearest); }
      }, { passive: true });
      rows.forEach(function (r, i) {
        r.addEventListener('mouseenter', function () { current = i; });
        r.addEventListener('focus', function () { current = i; });
      });
      nearest();
    }
  }
  /* pallini colore delle card: passandoci sopra (o toccandoli) cambiano foto e link della card */
  function setupCard(card) {
    if (card.__sch) return; card.__sch = true;
    var sws = Array.prototype.slice.call(card.querySelectorAll('.sch-sw'));
    if (!sws.length) return;
    var link = card.querySelector('[data-sch-card-link]');
    var media = card.querySelector('.sch-card__media');
    var img1 = card.querySelector('.sch-card__img1');
    var img2 = card.querySelector('.sch-card__img2');
    var sizeEls = Array.prototype.slice.call(card.querySelectorAll('.sch-size'));
    function pick(sw) {
      sws.forEach(function (o) { var on = o === sw; o.classList.toggle('is-on', on); o.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      if (sw.dataset.src && img1) { img1.loading = 'eager'; img1.srcset = sw.dataset.srcset || ''; img1.src = sw.dataset.src; }
      if (!sw.dataset.src) {
        /* colore senza foto propria: resta la foto attuale */
      } else if (sw.dataset.src2) {
        if (!img2 && media && img1) {
          img2 = img1.cloneNode(false);
          img2.className = 'sch-card__img2';
          img2.alt = '';
          media.insertBefore(img2, img1.nextSibling);
        }
        if (img2) { img2.hidden = false; img2.srcset = sw.dataset.srcset2 || ''; img2.src = sw.dataset.src2; }
      } else if (img2) {
        img2.hidden = true;
      }
      if (link && sw.dataset.url) link.href = sw.dataset.url;
      /* taglie disponibili per il colore scelto */
      if (sw.dataset.sizes && sizeEls.length) {
        var avail = sw.dataset.sizes;
        sizeEls.forEach(function (el, i) { el.classList.toggle('is-out', avail.charAt(i) !== '1'); });
      }
    }
    sws.forEach(function (sw) {
      if (finePointer) sw.addEventListener('mouseenter', function () { pick(sw); });
      sw.addEventListener('click', function (e) { e.preventDefault(); pick(sw); });
    });
  }
  function init(root) {
    var r = root || document;
    r.querySelectorAll('[data-sch-scroller]').forEach(setupScroller);
    r.querySelectorAll('[data-sch-tabs]').forEach(setupTabs);
    r.querySelectorAll('[data-sch-index]').forEach(setupIndex);
    r.querySelectorAll('[data-sch-card]').forEach(setupCard);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
